/**
 * AG Page Blocks — Promo countdown bar
 * Moves "above navbar" bars into document flow before the header.
 * Never uses position:fixed or position:sticky.
 *
 * Theme editor: Shopify re-renders the section and leaves the previously
 * moved bar in the header. Dedupe by id + remove on section:unload.
 */
(function () {
  'use strict';

  var SELECTOR = '.ag-pb-promo-bar[data-ag-pb-promo-placement="above_navbar"]';
  var HEADER_SELECTORS = [
    '.shopify-section--ag-custom-header',
    '.shopify-section--custom-header',
    '#shopify-section-header',
    '.shopify-section-header',
    'header[role="banner"]',
    '#main'
  ];

  function findAnchor() {
    var i;
    var el;
    for (i = 0; i < HEADER_SELECTORS.length; i++) {
      el = document.querySelector(HEADER_SELECTORS[i]);
      if (el && el.parentNode) return el;
    }
    return null;
  }

  function closestSectionId(el) {
    var section = el.closest('.shopify-section--ag-page-blocks, .shopify-section');
    return section && section.id ? section.id : '';
  }

  function ensureMarker(bar) {
    var id = bar.id;
    var marker;
    if (!id || !bar.parentNode) return null;

    marker = document.querySelector('[data-ag-pb-promo-bar-home="' + id + '"]');
    if (marker) return marker;

    marker = document.createElement('div');
    marker.setAttribute('data-ag-pb-promo-bar-home', id);
    marker.hidden = true;
    bar.parentNode.insertBefore(marker, bar);
    return marker;
  }

  function removeStaleMarkers(id, keeperParent) {
    var markers = document.querySelectorAll('[data-ag-pb-promo-bar-home="' + id + '"]');
    var i;
    for (i = 0; i < markers.length; i++) {
      if (keeperParent && markers[i].parentNode === keeperParent) continue;
      if (markers[i].parentNode && !markers[i].parentNode.querySelector(SELECTOR)) {
        markers[i].remove();
      }
    }
  }

  function pickKeeper(group) {
    var i;
    var bar;
    var inSection;

    for (i = 0; i < group.length; i++) {
      bar = group[i];
      inSection = bar.closest('.shopify-section--ag-page-blocks');
      if (inSection && bar.getAttribute('data-ag-pb-promo-placed') !== 'true') {
        return bar;
      }
    }

    for (i = 0; i < group.length; i++) {
      if (group[i].closest('.shopify-section--ag-page-blocks')) return group[i];
    }

    return group[group.length - 1];
  }

  function dedupe(bars) {
    var byId = {};
    var keepers = [];
    var i;
    var bar;
    var id;
    var group;
    var keeper;
    var key;

    for (i = 0; i < bars.length; i++) {
      bar = bars[i];
      id = bar.id || ('anon-' + i);
      if (!byId[id]) byId[id] = [];
      byId[id].push(bar);
    }

    for (key in byId) {
      if (!Object.prototype.hasOwnProperty.call(byId, key)) continue;
      group = byId[key];
      keeper = pickKeeper(group);
      for (i = 0; i < group.length; i++) {
        if (group[i] !== keeper) group[i].remove();
      }
      keepers.push(keeper);
    }

    return keepers;
  }

  function placeBar(bar) {
    var anchor = findAnchor();
    var sectionId;
    if (!anchor || bar === anchor) return;

    sectionId = closestSectionId(bar);
    if (sectionId) bar.setAttribute('data-ag-pb-promo-section', sectionId);

    ensureMarker(bar);

    if (bar.nextElementSibling === anchor) {
      bar.setAttribute('data-ag-pb-promo-placed', 'true');
      return;
    }

    anchor.parentNode.insertBefore(bar, anchor);
    bar.setAttribute('data-ag-pb-promo-placed', 'true');
  }

  function placeAll() {
    var bars = document.querySelectorAll(SELECTOR);
    var keepers = dedupe(bars);
    var i;
    for (i = 0; i < keepers.length; i++) {
      if (keepers[i].id) removeStaleMarkers(keepers[i].id, keepers[i].parentNode);
      placeBar(keepers[i]);
    }
  }

  function onSectionUnload(event) {
    var section = event.target;
    var sectionId = section && section.id;
    var placed;
    var i;
    if (!sectionId) return;

    placed = document.querySelectorAll(SELECTOR + '[data-ag-pb-promo-section="' + sectionId + '"]');
    for (i = 0; i < placed.length; i++) {
      placed[i].remove();
    }
  }

  placeAll();

  if (window.__AG_PB_PROMO_BAR_INIT__) return;
  window.__AG_PB_PROMO_BAR_INIT__ = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeAll);
  }
  document.addEventListener('shopify:section:load', placeAll);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
